const pin = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.83 2.65a.32.32 0 0 1 0 .17L6.2 6.17a.18.18 0 0 1-.09.1l-2.93 2h-.06a.25.25 0 0 0 0 .45L5.7 9.94l-1.79 4.7c-.1.29.46.5.62.24l2.64-4.24 2.6 1.25a.25.25 0 0 0 .36-.25l-.21-3.33a.59.59 0 0 1 0-.13l1.73-3.53a.52.52 0 0 1 .1-.11l1.11-.69a.26.26 0 0 0 0-.45L7.91 1a.27.27 0 0 0-.12 0 .25.25 0 0 0-.24.31z"/></svg>',
};

export { pin as default };
